// before 20-5-2026

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Grid,
//   Paper,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   CircularProgress,
//   Alert,
//   Chip,
//   IconButton,
//   Tooltip,
//   Stack,
//   InputAdornment,
//   Avatar,
//   LinearProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Modal,
// } from '@mui/material';
// import {
//   Refresh,
//   Download,
//   TrendingUp,
//   TrendingDown,
//   Person,
//   Assignment,
//   ShowChart,
//   CalendarToday,
//   Search,
//   Email,
//   Phone,
//   Business,
//   Campaign,
//   Category,
//   DateRange,
//   Info,
//   TableChart,
//   Visibility,
//   Close as CloseIcon,
//   ArrowBackIos as ArrowBackIosIcon,
//   ArrowForwardIos as ArrowForwardIosIcon,
// } from '@mui/icons-material';
// import { useDispatch, useSelector } from 'react-redux';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { getsalespreformancereportaction } from '../Redux/Actions/UsersAction';
// import {
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip as RechartsTooltip,
//   Legend,
//   ResponsiveContainer,
// } from 'recharts';
// import XLSX from '../utils/excelUtils';
// import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';

// export const SalesReportCountLeadsInMonths = () => {
//   const dispatch = useDispatch();
//   const user = JSON.parse(localStorage.getItem('user'));

//   // States
//   const [selectedSales, setSelectedSales] = useState('');
//   const [dateRange, setDateRange] = useState({
//     fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
//     toDate: new Date().toISOString().split('T')[0],
//   });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [leadTypeFilter, setLeadTypeFilter] = useState('all');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [infoDialogOpen, setInfoDialogOpen] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(null);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [exportLoading, setExportLoading] = useState(false);

//   // State لعرض تفاصيل الـ Lead
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [showLeadDetails, setShowLeadDetails] = useState(false);

//   // Redux states
//   const allSalesState = useSelector((state) => state.AllSales.sales);
//   const performanceReport = useSelector(
//     (state) => state.Allusers?.Get_users?.performanceReport || null,
//   );

//   // تحقق من أن allSales موجود وهو array
//   let allSales = Array.isArray(allSalesState?.data) ? allSalesState.data : [];

//   const salesLoading = allSalesState?.loading || false;

//   // Local states
//   const [localReportData, setLocalReportData] = useState(null);
//   const [localLeadsData, setLocalLeadsData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [reportLoading, setReportLoading] = useState(false);

//   // مصفوفة شهور السنة
//   const months = [
//     { id: 1, name: 'January', shortName: 'Jan', days: 31 },
//     { id: 2, name: 'February', shortName: 'Feb', days: 28 },
//     { id: 3, name: 'March', shortName: 'Mar', days: 31 },
//     { id: 4, name: 'April', shortName: 'Apr', days: 30 },
//     { id: 5, name: 'May', shortName: 'May', days: 31 },
//     { id: 6, name: 'June', shortName: 'Jun', days: 30 },
//     { id: 7, name: 'July', shortName: 'Jul', days: 31 },
//     { id: 8, name: 'August', shortName: 'Aug', days: 31 },
//     { id: 9, name: 'September', shortName: 'Sep', days: 30 },
//     { id: 10, name: 'October', shortName: 'Oct', days: 31 },
//     { id: 11, name: 'November', shortName: 'Nov', days: 30 },
//     { id: 12, name: 'December', shortName: 'Dec', days: 31 },
//   ];

//   // مصفوفة السنوات
//   const currentYear = new Date().getFullYear();
//   const years = Array.from({ length: 7 }, (_, i) => currentYear - 5 + i);

//   // دالة للتحقق من السنة الكبيسة
//   const isLeapYear = (year) => {
//     return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
//   };

//   // دالة للحصول على عدد أيام الشهر بناء على السنة
//   const getDaysInMonth = (monthId, year) => {
//     if (monthId === 2) {
//       return isLeapYear(year) ? 29 : 28;
//     }
//     const month = months.find((m) => m.id === monthId);
//     return month ? month.days : 31;
//   };

//   // دالة لفتح تفاصيل الـ Lead
//   const handleOpenLeadDetails = (lead) => {
//     console.log('Opening lead details for:', lead);
//     setSelectedLead(lead);
//     setShowLeadDetails(true);
//   };

//   // دالة لإغلاق تفاصيل الـ Lead
//   const handleCloseLeadDetails = () => {
//     setSelectedLead(null);
//     setShowLeadDetails(false);
//   };

//   // Fetch sales data on component mount
//   useEffect(() => {
//     dispatch(Get_All_Sales_Action());
//   }, [dispatch]);

//   // Auto-select current user if they are a sales person
//   useEffect(() => {
//     if (user?.role === 'sales' && user?.salesId) {
//       setSelectedSales(user.salesId);
//     }
//   }, [user]);

//   // Fetch report when sales or date range changes
//   useEffect(() => {
//     if (selectedSales && dateRange.fromDate && dateRange.toDate) {
//       setPage(0); // إعادة تعيين الصفحة عند تغيير الفلاتر
//       fetchReport();
//     }
//   }, [selectedSales, dateRange.fromDate, dateRange.toDate]);

//   const fetchReport = async (pageNum = 0, limit = rowsPerPage) => {
//     if (!selectedSales) {
//       setError('Please select a sales person first');
//       setInfoDialogOpen(true);
//       return;
//     }

//     try {
//       setReportLoading(true);
//       setError(null);

//       const apiPage = pageNum + 1; // API يتوقع page تبدأ من 1

//       console.log('Fetching report with:', {
//         salesId: selectedSales,
//         fromDate: dateRange.fromDate,
//         toDate: dateRange.toDate,
//         page: apiPage,
//         limit: limit,
//       });

//       const result = await dispatch(
//         getsalespreformancereportaction({
//           salesId: selectedSales,
//           fromDate: dateRange.fromDate,
//           toDate: dateRange.toDate,
//           page: apiPage,
//           limit: limit,
//         }),
//       );

//       console.log('Report result:', result);

//       if (result?.data?.data) {
//         const reportData = result.data.data;
//         setLocalReportData(reportData);

//         if (reportData.leads) {
//           console.log('Leads found:', reportData.leads.length);
//           console.log('Pagination data:', reportData.pagination);
//           setLocalLeadsData({
//             leads: reportData.leads,
//             pagination: reportData.pagination,
//             summary: reportData.summary,
//           });
//         } else {
//           console.log('No leads in reportData');
//           setLocalLeadsData(null);
//         }

//         if (reportData.summary) {
//           console.log('Summary found:', reportData.summary);
//         }
//       } else {
//         console.log('No data in result.data.data');
//         setLocalReportData(result?.data || null);
//         setLocalLeadsData(null);
//       }
//     } catch (error) {
//       console.error('Error fetching report:', error);
//       setError(error.message || 'Error loading report');
//       setLocalLeadsData(null);
//     } finally {
//       setReportLoading(false);
//     }
//   };

//   const handleSalesChange = (event) => {
//     setSelectedSales(event.target.value);
//   };

//   const handleDateChange = (field, value) => {
//     setDateRange((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleChangePage = (event, newPage) => {
//     console.log('Page changed to:', newPage);
//     console.log('Rows per page:', rowsPerPage);
//     setPage(newPage);
//     fetchReport(newPage, rowsPerPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     console.log('Rows per page changed to:', newRowsPerPage);
//     setRowsPerPage(newRowsPerPage);
//     setPage(0);

//     // إعادة جلب البيانات بالـ rowsPerPage الجديدة
//     fetchReport(0, newRowsPerPage);
//   };

//   const handleLeadTypeFilterChange = (type) => {
//     setLeadTypeFilter(type);
//     setPage(0);
//     // لا نحتاج لجلب بيانات جديدة من السيرفر، فقط تصفية محلي
//   };

//   const formatDateForExcel = (dateString) => {
//     if (!dateString) return '';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } catch (error) {
//       console.warn('Error formatting date for Excel:', dateString, error);
//       return dateString;
//     }
//   };

//   // دالة لتنسيق التاريخ للعرض في الجدول

//   const handleExportToExcel = async () => {
//     if (!selectedSales || !localReportData) {
//       setError('No data available to export');
//       return;
//     }

//     try {
//       setExportLoading(true);

//       // أولاً: نجمع كل البيانات من خلال جلب كل الصفحات
//       let allLeads = [];
//       let currentPage = 1;
//       let hasMoreData = true;
//       const pageSize = 200; // حجم معقول لكل طلب

//       // جلب البيانات صفحة صفحة
//       while (hasMoreData) {
//         try {
//           const result = await dispatch(
//             getsalespreformancereportaction({
//               salesId: selectedSales,
//               fromDate: dateRange.fromDate,
//               toDate: dateRange.toDate,
//               page: currentPage,
//               limit: pageSize,
//             }),
//           );

//           if (result?.data?.leads && Array.isArray(result.data.leads)) {
//             allLeads = [...allLeads, ...result.data.leads];

//             // تحقق إذا كان فيه صفحة تالية
//             const pagination = result.data.data.pagination || {};
//             if (pagination.hasNext && pagination.totalPages > currentPage) {
//               currentPage++;
//             } else {
//               hasMoreData = false;
//             }
//           } else {
//             hasMoreData = false;
//           }

//           // تحميل تدريجي - نوقف بعد 5000 سجل كحد أقصى
//           if (allLeads.length >= 5000) {
//             console.warn('Reached maximum export limit of 5000 records');
//             hasMoreData = false;
//           }
//         } catch (error) {
//           console.error('Error fetching page', currentPage, error);
//           hasMoreData = false;
//         }
//       }

//       if (allLeads.length === 0) {
//         throw new Error('No data available to export');
//       }

//       console.log('Total leads for export:', allLeads.length);

//       // تحضير بيانات الـ leads للتصدير
//       const leadsDataForExport = allLeads.map((lead, index) => ({
//         'No.': index + 1,
//         'Lead ID': lead._id || 'N/A',
//         Name: lead.name || 'Unnamed Lead',
//         Email: lead.email || '',
//         Phone: lead.phone || '',
//         Type: lead.leadType === 'fresh' ? 'Fresh' : 'Cold',
//         Project: lead.projectName || lead.project?.name || 'No Project',
//         Channel: lead.chanelName || lead.chanel?.name || '',
//         'Sales Person': lead.salesName || lead.sales?.name || '',
//         Stage: lead.stageName || lead.stage?.name || '',
//         'Assigned Date': lead.assignDate ? formatDateForExcel(lead.assignDate) : '',
//         'Created Date': lead.createdAt ? formatDateForExcel(lead.createdAt) : '',
//         'Last Updated': lead.updatedAt ? formatDateForExcel(lead.updatedAt) : '',
//       }));

//       // إنشاء بيانات الـ Summary
//       const totalLeads = allLeads.length;
//       const freshLeads = allLeads.filter((l) => l.leadType === 'fresh').length;
//       const coldLeads = allLeads.filter((l) => l.leadType === 'cold').length;

//       const summaryDataForExport = [
//         {
//           Metric: 'Total Leads',
//           Value: totalLeads,
//         },
//         {
//           Metric: 'Fresh Leads',
//           Value: freshLeads,
//         },
//         {
//           Metric: 'Cold Leads',
//           Value: coldLeads,
//         },
//         {
//           Metric: 'Conversion Rate',
//           Value: totalLeads > 0 ? `${((freshLeads / totalLeads) * 100).toFixed(1)}%` : '0%',
//         },
//       ];

//       // إنشاء معلومات التقرير
//       const reportInfo = [
//         {
//           'Report Information': 'Sales Performance Report',
//           Value: '',
//         },
//         {
//           'Report Information': 'Generated Date',
//           Value: new Date().toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//           }),
//         },
//         {
//           'Report Information': 'Sales Person',
//           Value: selectedSalesInfo?.name || selectedSales,
//         },
//         {
//           'Report Information': 'Period',
//           Value: `${formatDate(dateRange.fromDate)} - ${formatDate(dateRange.toDate)}`,
//         },
//         {
//           'Report Information': 'Total Records',
//           Value: allLeads.length,
//         },
//         {
//           'Report Information': 'Export Limit',
//           Value: allLeads.length >= 5000 ? 'Limited to 5000 records' : 'All records',
//         },
//       ];

//       // إنشاء ورقة عمل جديدة
//       const wb = XLSX.utils.book_new();

//       // إضافة ورقة للـ Report Info
//       const wsReportInfo = XLSX.utils.json_to_sheet(reportInfo);
//       XLSX.utils.book_append_sheet(wb, wsReportInfo, 'Report Info');

//       // إضافة ورقة للـ Summary
//       const wsSummary = XLSX.utils.json_to_sheet(summaryDataForExport);
//       XLSX.utils.book_append_sheet(wb, wsSummary, 'Summary');

//       // إضافة ورقة للـ Leads
//       const wsLeads = XLSX.utils.json_to_sheet(leadsDataForExport);
//       XLSX.utils.book_append_sheet(wb, wsLeads, 'Leads Details');

//       // تنسيق الأعمدة
//       const wscols = [
//         { wch: 8 }, // No.
//         { wch: 25 }, // Lead ID
//         { wch: 20 }, // Name
//         { wch: 25 }, // Email
//         { wch: 15 }, // Phone
//         { wch: 10 }, // Type
//         { wch: 20 }, // Project
//         { wch: 15 }, // Channel
//         { wch: 20 }, // Sales Person
//         { wch: 15 }, // Stage
//         { wch: 15 }, // Assigned Date
//         { wch: 15 }, // Created Date
//         { wch: 15 }, // Last Updated
//       ];
//       wsLeads['!cols'] = wscols;

//       // تنسيق خلايا الـ Summary
//       const wsSummaryCols = [
//         { wch: 20 }, // Metric
//         { wch: 15 }, // Value
//       ];
//       wsSummary['!cols'] = wsSummaryCols;

//       // تنسيق خلايا الـ Report Info
//       const wsInfoCols = [
//         { wch: 25 }, // Report Information
//         { wch: 40 }, // Value
//       ];
//       wsReportInfo['!cols'] = wsInfoCols;

//       // توليد اسم الملف
//       const salesName = selectedSalesInfo?.name || 'sales';
//       const cleanSalesName = salesName.replace(/[^a-zA-Z0-9]/g, '_');
//       const fileName = `Sales_Report_${cleanSalesName}_${dateRange.fromDate}_to_${dateRange.toDate}.xlsx`;

//       // حفظ الملف
//       XLSX.writeFile(wb, fileName);

//       console.log('Excel file exported successfully with', allLeads.length, 'records');

//       // إظهار رسالة نجاح
//       setError(null);
//     } catch (error) {
//       console.error('Error exporting to Excel:', error);
//       setError(error.message || 'Error exporting report to Excel. Please try again.');
//     } finally {
//       setExportLoading(false);
//     }
//   };

//   const handleQuickDateRange = (months) => {
//     if (!selectedSales) {
//       setInfoDialogOpen(true);
//       return;
//     }

//     const toDate = new Date();
//     const fromDate = new Date();
//     fromDate.setMonth(fromDate.getMonth() - months);

//     setDateRange({
//       fromDate: fromDate.toISOString().split('T')[0],
//       toDate: toDate.toISOString().split('T')[0],
//     });
//   };

//   // دالة لاختيار شهر
//   const handleMonthSelect = (monthId) => {
//     if (!selectedSales) {
//       setInfoDialogOpen(true);
//       return;
//     }

//     const month = monthId - 1;
//     const daysInMonth = getDaysInMonth(monthId, selectedYear);

//     const firstDay = new Date(selectedYear, month, 1);
//     const lastDay = new Date(selectedYear, month, daysInMonth);

//     setSelectedMonth(monthId);
//     setDateRange({
//       fromDate: firstDay.toISOString().split('T')[0],
//       toDate: lastDay.toISOString().split('T')[0],
//     });
//   };

//   // دالة للشهر الحالي
//   const handleCurrentMonth = () => {
//     if (!selectedSales) {
//       setInfoDialogOpen(true);
//       return;
//     }

//     const currentDate = new Date();
//     const currentMonth = currentDate.getMonth() + 1;
//     const currentYear = currentDate.getFullYear();

//     setSelectedYear(currentYear);
//     handleMonthSelect(currentMonth);
//   };

//   // دالة عند تغيير السنة
//   const handleYearChange = (event) => {
//     const newYear = parseInt(event.target.value);
//     setSelectedYear(newYear);

//     if (selectedMonth) {
//       setTimeout(() => {
//         handleMonthSelect(selectedMonth);
//       }, 100);
//     }
//   };

//   // دالة لرسم التسميات على مخطط Pie
//   const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, name }) => {
//     const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//     const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
//     const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

//     return (
//       <text
//         x={x}
//         y={y}
//         fill="white"
//         textAnchor={x > cx ? 'start' : 'end'}
//         dominantBaseline="central"
//       >
//         {`${(percent * 100).toFixed(0)}%`}
//       </text>
//     );
//   };

//   // Process leads data
//   const leadsData =
//     localLeadsData?.leads || localReportData?.leads || localReportData?.data?.leads || [];

//   console.log('Current leadsData:', {
//     length: leadsData.length,
//     data: leadsData,
//   });

//   const paginationData = localLeadsData?.pagination ||
//     localReportData?.pagination ||
//     localReportData?.data?.pagination || {
//       total: leadsData.length,
//       page: page + 1,
//       limit: rowsPerPage,
//       totalPages: Math.ceil(leadsData.length / rowsPerPage),
//       hasNext: false,
//       hasPrev: false,
//     };

//   const summaryData = localLeadsData?.summary ||
//     localReportData?.summary ||
//     localReportData?.data?.summary || {
//       freshLeads: 0,
//       coldLeads: 0,
//       totalLeads: 0,
//     };

//   const preparePieData = () => {
//     const summary = summaryData || {};

//     const fresh = summary.freshLeads || leadsData.filter((l) => l.leadType === 'fresh').length || 0;

//     const cold = summary.coldLeads || leadsData.filter((l) => l.leadType === 'cold').length || 0;

//     console.log('Pie Data - Fresh:', fresh, 'Cold:', cold);

//     return [
//       {
//         name: 'Fresh Leads',
//         value: fresh,
//         color: '#4CAF50',
//       },
//       {
//         name: 'Cold Leads',
//         value: cold,
//         color: '#F44336',
//       },
//     ];
//   };

//   // Get selected sales info
//   const selectedSalesInfo =
//     allSales && Array.isArray(allSales) ? allSales.find((s) => s._id === selectedSales) : null;

//   // Filter leads based on search and type (عميل side فقط)
//   const filteredLeads = leadsData.filter((lead) => {
//     const leadName = lead.name || '';
//     const leadEmail = lead.email || '';
//     const leadPhone = lead.phone || '';

//     const matchesSearch =
//       searchTerm === '' ||
//       leadName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       leadEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       leadPhone.toString().includes(searchTerm);

//     const leadType = lead.leadType || 'fresh';
//     const matchesType = leadTypeFilter === 'all' || leadType === leadTypeFilter;

//     return matchesSearch && matchesType;
//   });

//   // Format date function
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//       });
//     } catch (error) {
//       console.error('Error formatting date:', error);
//       return 'Invalid Date';
//     }
//   };

//   // Get initials for avatar
//   const getInitials = (name) => {
//     if (!name) return '?';
//     return name
//       .split(' ')
//       .map((n) => n[0])
//       .join('')
//       .toUpperCase();
//   };

//   console.log('Component state:', {
//     localReportData,
//     localLeadsData,
//     leadsDataLength: leadsData.length,
//     summaryData,
//     selectedSales,
//     paginationData,
//     page,
//     rowsPerPage,
//   });

//   return (
//     <Container className="startpage" maxWidth="xl" sx={{ py: 4, minHeight: '100vh' }}>
//       {/* Header */}
//       <Box sx={{ mb: 4 }}>
//         <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
//           📊 Sales Performance Dashboard
//         </Typography>
//         <Typography variant="subtitle1" color="text.secondary">
//           Comprehensive analysis of sales performance and lead tracking
//         </Typography>
//       </Box>

//       {/* Filters Section */}
//       <Paper sx={{ p: 3, mb: 4, borderRadius: 2, boxShadow: 1 }}>
//         <Grid container spacing={3} alignItems="center">
//           <Grid item xs={12} md={3}>
//             <FormControl fullWidth>
//               <InputLabel>Select Sales Person</InputLabel>
//               <Select
//                 value={selectedSales}
//                 onChange={handleSalesChange}
//                 label="Select Sales Person"
//                 disabled={salesLoading}
//               >
//                 <MenuItem value="">
//                   <em>All Sales Persons</em>
//                 </MenuItem>
//                 {Array.isArray(allSales) &&
//                   allSales.map((sales) => (
//                     <MenuItem key={sales._id} value={sales._id}>
//                       <Box display="flex" alignItems="center">
//                         <Avatar sx={{ width: 24, height: 24, mr: 1, bgcolor: 'primary.main' }}>
//                           {getInitials(sales.name)}
//                         </Avatar>
//                         {sales.name || sales._id}
//                       </Box>
//                     </MenuItem>
//                   ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={12} md={2}>
//             <TextField
//               fullWidth
//               label="From Date"
//               type="date"
//               value={dateRange.fromDate}
//               onChange={(e) => handleDateChange('fromDate', e.target.value)}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <CalendarToday fontSize="small" />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={2}>
//             <TextField
//               fullWidth
//               label="To Date"
//               type="date"
//               value={dateRange.toDate}
//               onChange={(e) => handleDateChange('toDate', e.target.value)}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <CalendarToday fontSize="small" />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <Stack direction="row" spacing={1} alignItems="center">
//               <Typography variant="body2" color="text.secondary">
//                 Quick Range:
//               </Typography>
//               <Chip
//                 label="Last Month"
//                 size="small"
//                 onClick={() => handleQuickDateRange(1)}
//                 color={
//                   dateRange.fromDate ===
//                   new Date(new Date().setMonth(new Date().getMonth() - 1))
//                     .toISOString()
//                     .split('T')[0]
//                     ? 'primary'
//                     : 'default'
//                 }
//               />
//               <Chip label="Last 3 Months" size="small" onClick={() => handleQuickDateRange(3)} />
//               <Chip label="Last Year" size="small" onClick={() => handleQuickDateRange(12)} />
//             </Stack>
//           </Grid>

//           <Grid item xs={12} md={2}>
//             <Button
//               fullWidth
//               variant="contained"
//               onClick={() => fetchReport(page, rowsPerPage)}
//               disabled={reportLoading}
//               startIcon={<Refresh />}
//             >
//               {reportLoading ? 'Loading...' : 'Refresh'}
//             </Button>
//           </Grid>
//         </Grid>

//         {/* Months and Years Selection Section */}
//         <Box mt={3}>
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//             <Typography variant="subtitle1" fontWeight="bold" color="primary">
//               📅 Select Month & Year
//             </Typography>
//             <Box display="flex" alignItems="center" gap={2}>
//               <Chip
//                 label="Current Month"
//                 size="small"
//                 color="secondary"
//                 onClick={handleCurrentMonth}
//                 variant={selectedMonth === new Date().getMonth() + 1 ? 'filled' : 'outlined'}
//               />

//               <FormControl size="small" sx={{ minWidth: 120 }}>
//                 <InputLabel>Year</InputLabel>
//                 <Select value={selectedYear} onChange={handleYearChange} label="Year">
//                   {years.map((year) => (
//                     <MenuItem key={year} value={year}>
//                       {year}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>
//           </Box>

//           <Grid container spacing={1}>
//             {months.map((month) => {
//               const isCurrentMonth = selectedMonth === month.id;
//               const daysInMonth = getDaysInMonth(month.id, selectedYear);
//               const isLeapYearMonth = month.id === 2 && isLeapYear(selectedYear);

//               return (
//                 <Grid item key={month.id}>
//                   <Chip
//                     label={
//                       <Box display="flex" alignItems="center">
//                         <span>{month.shortName}</span>
//                         {isLeapYearMonth && (
//                           <Typography variant="caption" sx={{ ml: 0.5, color: 'warning.main' }}>
//                             *
//                           </Typography>
//                         )}
//                       </Box>
//                     }
//                     onClick={() => handleMonthSelect(month.id)}
//                     color={isCurrentMonth ? 'primary' : 'default'}
//                     variant={isCurrentMonth ? 'filled' : 'outlined'}
//                     sx={{
//                       fontWeight: isCurrentMonth ? 'bold' : 'normal',
//                       minWidth: 60,
//                       cursor: 'pointer',
//                       '&:hover': {
//                         backgroundColor: isCurrentMonth ? 'primary.main' : 'action.hover',
//                       },
//                       position: 'relative',
//                     }}
//                   />
//                 </Grid>
//               );
//             })}
//           </Grid>

//           {selectedMonth && (
//             <Box mt={2} p={1.5} bgcolor="info.light" borderRadius={1}>
//               <Grid container spacing={2} alignItems="center">
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="body2" color="info.dark">
//                     <strong>Selected:</strong> {months.find((m) => m.id === selectedMonth)?.name}{' '}
//                     {selectedYear}
//                   </Typography>
//                   <Typography variant="caption" color="info.dark">
//                     From: {formatDate(dateRange.fromDate)}
//                     &nbsp;&nbsp;|&nbsp;&nbsp; To: {formatDate(dateRange.toDate)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="caption" color="info.dark">
//                     <strong>Days in month:</strong> {getDaysInMonth(selectedMonth, selectedYear)}{' '}
//                     days
//                     {getDaysInMonth(selectedMonth, selectedYear) === 29 && (
//                       <span> (Leap Year)</span>
//                     )}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}

//           <Box mt={1}>
//             <Typography variant="caption" color="text.secondary">
//               * February in leap year has 29 days
//             </Typography>
//           </Box>
//         </Box>

//         {selectedSalesInfo && (
//           <Box mt={3} p={2} bgcolor="primary.light" borderRadius={1}>
//             <Grid container alignItems="center" spacing={2}>
//               <Grid item>
//                 <Avatar sx={{ bgcolor: 'primary.main' }}>
//                   {getInitials(selectedSalesInfo.name)}
//                 </Avatar>
//               </Grid>
//               <Grid item xs>
//                 <Typography variant="subtitle2" color="white">
//                   <strong>{selectedSalesInfo.name}</strong>
//                   {selectedSalesInfo.email && ` • ${selectedSalesInfo.email}`}
//                   {selectedSalesInfo.phone && ` • ${selectedSalesInfo.phone}`}
//                 </Typography>
//                 {selectedSalesInfo.teamleader && (
//                   <Typography variant="caption" color="white" display="block">
//                     Team Lead: {selectedSalesInfo.teamleader.name}
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item>
//                 <Stack direction="row" spacing={1}>
//                   <Button
//                     size="small"
//                     variant="contained"
//                     color="secondary"
//                     startIcon={<TableChart />}
//                     onClick={handleExportToExcel}
//                     disabled={!localReportData || exportLoading}
//                   >
//                     {exportLoading ? 'Exporting...' : 'Export Excel'}
//                   </Button>
//                 </Stack>
//               </Grid>
//             </Grid>
//           </Box>
//         )}
//       </Paper>

//       {/* Error Display */}
//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           ❌ {error}
//         </Alert>
//       )}

//       {/* Loading State */}
//       {(reportLoading || loading || exportLoading) && (
//         <Box sx={{ mb: 4 }}>
//           <LinearProgress />
//           <Box display="flex" justifyContent="center" mt={2}>
//             <CircularProgress size={24} sx={{ mr: 2 }} />
//             <Typography>{exportLoading ? 'Exporting to Excel...' : 'Loading data...'}</Typography>
//           </Box>
//         </Box>
//       )}

//       {/* Main Content - Charts and Leads in same page */}
//       {localReportData && !reportLoading && (
//         <>
//           {/* Key Metrics Cards */}
//           <Grid container spacing={4} mb={4}>
//             <Grid item xs={12} sm={6} md={3}>
//               <Card
//                 sx={{
//                   height: '100%',
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   borderLeft: '4px solid #667eea',
//                   '&:hover': { transform: 'translateY(-4px)', transition: 'transform 0.3s' },
//                 }}
//               >
//                 <CardContent>
//                   <Box display="flex" alignItems="center" mb={2}>
//                     <Box
//                       sx={{
//                         p: 1,
//                         borderRadius: 2,
//                         bgcolor: 'primary.light',
//                         mr: 2,
//                       }}
//                     >
//                       <Person sx={{ color: 'primary.main' }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h6" color="text.secondary">
//                         Total Leads
//                       </Typography>
//                       <Typography variant="h3" fontWeight="bold" color="primary">
//                         {paginationData.total || summaryData.totalLeads || 0}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Typography variant="caption" color="text.secondary">
//                     Acquired in selected period
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Card
//                 sx={{
//                   height: '100%',
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   borderLeft: '4px solid #4CAF50',
//                   '&:hover': { transform: 'translateY(-4px)', transition: 'transform 0.3s' },
//                 }}
//               >
//                 <CardContent>
//                   <Box display="flex" alignItems="center" mb={2}>
//                     <Box
//                       sx={{
//                         p: 1,
//                         borderRadius: 2,
//                         bgcolor: 'success.light',
//                         mr: 2,
//                       }}
//                     >
//                       <TrendingUp sx={{ color: 'success.main' }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h6" color="text.secondary">
//                         Fresh Leads
//                       </Typography>
//                       <Typography variant="h3" fontWeight="bold" color="success.main">
//                         {summaryData.freshLeads || 0}
//                       </Typography>
//                       <Typography variant="body2" color="success.main">
//                         {summaryData.totalLeads
//                           ? `${((summaryData.freshLeads / summaryData.totalLeads) * 100).toFixed(1)}%`
//                           : '0%'}{' '}
//                         of total
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Typography variant="caption" color="text.secondary">
//                     New prospects
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Card
//                 sx={{
//                   height: '100%',
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   borderLeft: '4px solid #f44336',
//                   '&:hover': { transform: 'translateY(-4px)', transition: 'transform 0.3s' },
//                 }}
//               >
//                 <CardContent>
//                   <Box display="flex" alignItems="center" mb={2}>
//                     <Box
//                       sx={{
//                         p: 1,
//                         borderRadius: 2,
//                         bgcolor: 'error.light',
//                         mr: 2,
//                       }}
//                     >
//                       <TrendingDown sx={{ color: 'error.main' }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h6" color="text.secondary">
//                         Cold Leads
//                       </Typography>
//                       <Typography variant="h3" fontWeight="bold" color="error.main">
//                         {summaryData.coldLeads || 0}
//                       </Typography>
//                       <Typography variant="body2" color="error.main">
//                         {summaryData.totalLeads
//                           ? `${((summaryData.coldLeads / summaryData.totalLeads) * 100).toFixed(1)}%`
//                           : '0%'}{' '}
//                         of total
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Typography variant="caption" color="text.secondary">
//                     Re-engaged prospects
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid>

//             {/* <Grid item xs={12} sm={6} md={3}>
//               <Card sx={{ 
//                 height: '100%', 
//                 borderRadius: 2,
//                 boxShadow: 2,
//                 borderLeft: '4px solid #FF9800',
//                 '&:hover': { transform: 'translateY(-4px)', transition: 'transform 0.3s' }
//               }}>
//                 <CardContent>
//                   <Box display="flex" alignItems="center" mb={2}>
//                     <Box sx={{ 
//                       p: 1, 
//                       borderRadius: 2, 
//                       bgcolor: 'warning.light',
//                       mr: 2 
//                     }}>
//                       <ShowChart sx={{ color: 'warning.main' }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h6" color="text.secondary">
//                         Conversion Rate
//                       </Typography>
//                       <Typography variant="h3" fontWeight="bold" color="warning.main">
//                         {summaryData.totalLeads ? 
//                           `${((summaryData.freshLeads / summaryData.totalLeads) * 100).toFixed(1)}%` : 
//                           '0%'}
//                       </Typography>
//                       <Typography variant="body2" color="warning.main">
//                         Fresh to Cold ratio
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Typography variant="caption" color="text.secondary">
//                     Lead quality indicator
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid> */}
//           </Grid>

//           {/* Charts and Leads Table Section */}
//           <Grid container spacing={3} mb={4}>
//             {/* Leads Composition Chart */}
//             <Grid item xs={12} md={4}>
//               <Paper sx={{ p: 3, height: '100%', borderRadius: 2, boxShadow: 2, minHeight: 400 }}>
//                 <Typography variant="h6" mb={2} color="primary">
//                   Leads Composition
//                 </Typography>
//                 <ResponsiveContainer width="100%" height={300}>
//                   <PieChart>
//                     <Pie
//                       data={preparePieData()}
//                       cx="50%"
//                       cy="50%"
//                       labelLine={false}
//                       label={renderCustomizedLabel}
//                       outerRadius={100}
//                       innerRadius={50}
//                       paddingAngle={5}
//                       dataKey="value"
//                     >
//                       {preparePieData().map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={entry.color} />
//                       ))}
//                     </Pie>
//                     <RechartsTooltip formatter={(value, name) => [`${value} leads`, name]} />
//                     <Legend />
//                   </PieChart>
//                 </ResponsiveContainer>
//                 <Box mt={2} textAlign="center">
//                   <Typography variant="body2" color="text.secondary">
//                     Total: {preparePieData().reduce((sum, item) => sum + item.value, 0)} leads
//                   </Typography>
//                 </Box>
//               </Paper>
//             </Grid>

//             {/* Leads Table */}
//             <Grid item xs={12} md={8}>
//               <Paper
//                 sx={{
//                   p: 3,
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   height: '100%',
//                   minHeight: 400,
//                   position: 'relative',
//                 }}
//               >
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//                   <Box>
//                     <Typography variant="h6" color="primary">
//                       📋 Leads Details
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       Showing {leadsData.length} of {paginationData.total} leads (Page{' '}
//                       {paginationData.page || page + 1} of{' '}
//                       {paginationData.totalPages || Math.ceil(paginationData.total / rowsPerPage)})
//                     </Typography>
//                   </Box>

//                   {/* Search and Filters */}
//                   <Box display="flex" gap={2} alignItems="center">
//                     <TextField
//                       size="small"
//                       placeholder="Search by name, email, or phone..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <Search fontSize="small" />
//                           </InputAdornment>
//                         ),
//                       }}
//                       sx={{ width: 250 }}
//                     />

//                     <Stack direction="row" spacing={1}>
//                       <Chip
//                         label="All"
//                         size="small"
//                         color={leadTypeFilter === 'all' ? 'primary' : 'default'}
//                         onClick={() => handleLeadTypeFilterChange('all')}
//                       />
//                       <Chip
//                         label="Fresh"
//                         size="small"
//                         color={leadTypeFilter === 'fresh' ? 'success' : 'default'}
//                         onClick={() => handleLeadTypeFilterChange('fresh')}
//                       />
//                       <Chip
//                         label="Cold"
//                         size="small"
//                         color={leadTypeFilter === 'cold' ? 'error' : 'default'}
//                         onClick={() => handleLeadTypeFilterChange('cold')}
//                       />
//                     </Stack>
//                   </Box>
//                 </Box>

//                 <TableContainer sx={{ maxHeight: 300, overflow: 'auto', position: 'relative' }}>
//                   {loading && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         bottom: 0,
//                         bgcolor: 'rgba(255,255,255,0.7)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         zIndex: 1,
//                       }}
//                     >
//                       <CircularProgress />
//                     </Box>
//                   )}
//                   <Table stickyHeader size="small">
//                     <TableHead>
//                       <TableRow sx={{ bgcolor: 'primary.light' }}>
//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>#</TableCell>
//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>Lead</TableCell>
//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>Contact</TableCell>
//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>Type</TableCell>
//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>Project</TableCell>
//                         {/* <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>Ch</TableCell> */}

//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>
//                           Assigned Date
//                         </TableCell>
//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>
//                           Creation Date
//                         </TableCell>

//                         <TableCell sx={{ color: '#102dff', fontWeight: 'bold' }}>Actions</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {searchTerm || leadTypeFilter !== 'all' ? (
//                         // If filtering locally, show filtered results
//                         filteredLeads.length > 0 ? (
//                           filteredLeads.map((lead, index) => {
//                             const leadName = lead.name || 'Unnamed Lead';
//                             const leadEmail = lead.email || '';
//                             const leadPhone = lead.phone || '';
//                             const leadType = lead.leadType || 'fresh';
//                             const projectName =
//                               lead.projectName || lead.project?.name || 'No Project';
//                             const assignDate = lead.assignDate || lead.createdAt || '';

//                             return (
//                               <TableRow
//                                 key={lead._id}
//                                 hover
//                                 sx={{
//                                   '&:nth-of-type(even)': { bgcolor: 'action.hover' },
//                                   '&:hover': { cursor: 'pointer' },
//                                 }}
//                               >
//                                 <TableCell>
//                                   <Typography variant="body2">{index + 1}</Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                   <Box display="flex" alignItems="center">
//                                     <Avatar
//                                       sx={{ width: 28, height: 28, mr: 2, bgcolor: 'primary.main' }}
//                                     >
//                                       {getInitials(leadName)}
//                                     </Avatar>
//                                     <Box>
//                                       <Typography
//                                         variant="body2"
//                                         // fontWeight="medium"
//                                         // sx={{
//                                         //   cursor: 'pointer',
//                                         //   color: '#333 !important',
//                                         //   // textDecoration: 'underline',
//                                         //   // textUnderlineOffset: '3px',
//                                         //   // '&:hover': {
//                                         //   //   color: 'primary.dark',
//                                         //   //   textDecorationThickness: '2px'
//                                         //   // }
//                                         // }}
//                                         // onClick={() => handleOpenLeadDetails(lead)}
//                                       >
//                                         {leadName}
//                                       </Typography>
//                                       <Typography variant="caption" color="text.secondary">
//                                         ID: {lead._id?.substring(0, 8)}...
//                                       </Typography>
//                                     </Box>
//                                   </Box>
//                                 </TableCell>
//                                 <TableCell>
//                                   <Stack spacing={0.5}>
//                                     {leadEmail && (
//                                       <Typography variant="caption" color="text.secondary">
//                                         {leadEmail}
//                                       </Typography>
//                                     )}
//                                     {leadPhone && (
//                                       <Typography variant="caption" color="text.secondary">
//                                         {leadPhone}
//                                       </Typography>
//                                     )}
//                                   </Stack>
//                                 </TableCell>
//                                 <TableCell>
//                                   <Chip
//                                     label={leadType === 'fresh' ? 'Fresh' : 'Cold'}
//                                     size="small"
//                                     sx={{
//                                       bgcolor: leadType === 'fresh' ? '#4CAF50' : '#F44336',
//                                       color: 'white',
//                                       fontWeight: 'bold',
//                                     }}
//                                   />
//                                 </TableCell>
//                                 <TableCell>
//                                   <Typography variant="body2">{projectName}</Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                   <Typography variant="body2">{formatDate(assignDate)}</Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                   <Tooltip title="View Lead Details">
//                                     <IconButton
//                                       size="small"
//                                       color="primary"
//                                       onClick={() => handleOpenLeadDetails(lead)}
//                                     >
//                                       <Visibility fontSize="small" />
//                                     </IconButton>
//                                   </Tooltip>
//                                 </TableCell>
//                               </TableRow>
//                             );
//                           })
//                         ) : (
//                           <TableRow>
//                             <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//                               <Typography color="text.secondary">
//                                 No leads found matching your criteria
//                               </Typography>
//                             </TableCell>
//                           </TableRow>
//                         )
//                       ) : // If no filtering, show all leads from current page
//                       leadsData.length > 0 ? (
//                         leadsData.map((lead, index) => {
//                           const leadName = lead.name || 'Unnamed Lead';
//                           const leadEmail = lead.email || '';
//                           const leadPhone = lead.phone || '';
//                           const leadType = lead.leadType || 'fresh';
//                           const projectName =
//                             lead.projectName || lead.project?.name || 'No Project';
//                           const assignDate = lead.assignDate || lead.createdAt || '';
//                           const createdat = lead.createdAt;
//                           // حساب الرقم الحقيقي بناءً على الصفحة
//                           const itemNumber = page * rowsPerPage + index + 1;

//                           return (
//                             <TableRow
//                               key={lead._id}
//                               hover
//                               sx={{
//                                 '&:nth-of-type(even)': { bgcolor: 'action.hover' },
//                                 '&:hover': { cursor: 'pointer' },
//                               }}
//                             >
//                               <TableCell>
//                                 <Typography variant="body2">{itemNumber}</Typography>
//                               </TableCell>
//                               <TableCell>
//                                 <Box display="flex" alignItems="center">
//                                   <Avatar
//                                     sx={{ width: 28, height: 28, mr: 2, bgcolor: 'primary.main' }}
//                                   >
//                                     {getInitials(leadName)}
//                                   </Avatar>
//                                   <Box>
//                                     <Typography
//                                       variant="body2"
//                                       fontWeight="medium"
//                                       sx={{
//                                         cursor: 'pointer',
//                                         color: '#102dff',
//                                         textDecoration: 'underline',
//                                         textUnderlineOffset: '3px',
//                                         '&:hover': {
//                                           color: 'primary.dark',
//                                           textDecorationThickness: '2px',
//                                         },
//                                       }}
//                                       onClick={() => handleOpenLeadDetails(lead)}
//                                     >
//                                       {leadName}
//                                     </Typography>
//                                     <Typography variant="caption" color="text.secondary">
//                                       ID: {lead._id?.substring(0, 8)}...
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </TableCell>
//                               <TableCell>
//                                 <Stack spacing={0.5}>
//                                   {leadEmail && (
//                                     <Typography variant="caption" color="text.secondary">
//                                       {leadEmail}
//                                     </Typography>
//                                   )}
//                                   {leadPhone && (
//                                     <Typography variant="caption" color="text.secondary">
//                                       {leadPhone}
//                                     </Typography>
//                                   )}
//                                 </Stack>
//                               </TableCell>
//                               <TableCell>
//                                 <Chip
//                                   label={leadType === 'fresh' ? 'Fresh' : 'Cold'}
//                                   size="small"
//                                   sx={{
//                                     bgcolor: leadType === 'fresh' ? '#4CAF50' : '#F44336',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                   }}
//                                 />
//                               </TableCell>
//                               <TableCell>
//                                 <Typography variant="body2">{projectName}</Typography>
//                               </TableCell>
//                               <TableCell>
//                                 <Typography variant="body2">{formatDate(assignDate)}</Typography>
//                               </TableCell>

//                               <TableCell>
//                                 <Typography variant="body2">{formatDate(createdat)}</Typography>
//                               </TableCell>

//                               <TableCell>
//                                 <Tooltip title="View Lead Details">
//                                   <IconButton
//                                     size="small"
//                                     color="primary"
//                                     onClick={() => handleOpenLeadDetails(lead)}
//                                   >
//                                     <Visibility fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </TableCell>
//                             </TableRow>
//                           );
//                         })
//                       ) : (
//                         <TableRow>
//                           <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//                             <Typography color="text.secondary">
//                               No leads available for this page
//                             </Typography>
//                           </TableCell>
//                         </TableRow>
//                       )}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 {/* Pagination */}
//                 <TablePagination
//                   component="div"
//                   count={paginationData.total || 0}
//                   page={page}
//                   onPageChange={handleChangePage}
//                   rowsPerPage={rowsPerPage}
//                   onRowsPerPageChange={handleChangeRowsPerPage}
//                   rowsPerPageOptions={[5, 10, 25, 50]}
//                   labelRowsPerPage="Rows per page:"
//                   labelDisplayedRows={({ from, to, count }) =>
//                     `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
//                   }
//                   disabled={loading || reportLoading}
//                 />

//                 {/* Manual Pagination Controls */}
//                 <Box display="flex" justifyContent="center" alignItems="center" gap={2} mt={2}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={() => handleChangePage(null, page - 1)}
//                     disabled={page === 0 || loading || reportLoading || !paginationData.hasPrev}
//                     startIcon={<ArrowBackIosIcon fontSize="small" />}
//                   >
//                     Previous
//                   </Button>

//                   <Typography variant="body2">
//                     Page {paginationData.page || page + 1} of{' '}
//                     {paginationData.totalPages || Math.ceil(paginationData.total / rowsPerPage)}
//                   </Typography>

//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={() => handleChangePage(null, page + 1)}
//                     disabled={
//                       page >=
//                         (paginationData.totalPages ||
//                           Math.ceil(paginationData.total / rowsPerPage)) -
//                           1 ||
//                       loading ||
//                       reportLoading ||
//                       !paginationData.hasNext
//                     }
//                     endIcon={<ArrowForwardIosIcon fontSize="small" />}
//                   >
//                     Next
//                   </Button>
//                 </Box>

//                 {/* Pagination Info */}
//                 <Box mt={2} textAlign="center">
//                   <Typography variant="caption" color="text.secondary">
//                     Showing page {paginationData.page || page + 1} of{' '}
//                     {paginationData.totalPages || Math.ceil(paginationData.total / rowsPerPage)} •
//                     Total: {paginationData.total} leads • Limit:{' '}
//                     {paginationData.limit || rowsPerPage} per page
//                   </Typography>
//                 </Box>
//               </Paper>
//             </Grid>
//           </Grid>

//           {/* Insights Section */}
//           <Paper sx={{ p: 3, mb: 4, borderRadius: 2, boxShadow: 2 }}>
//             <Typography variant="h6" mb={3} color="primary">
//               💡 Performance Insights
//             </Typography>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <Card variant="outlined" sx={{ height: '100%' }}>
//                   <CardContent>
//                     <Box display="flex" alignItems="center" mb={2}>
//                       <TrendingUp sx={{ color: 'success.main', mr: 1 }} />
//                       <Typography variant="subtitle1" color="success.main">
//                         ✅ Strong Points
//                       </Typography>
//                     </Box>
//                     <Stack spacing={1}>
//                       <Typography variant="body2">
//                         • Fresh lead acquisition is at{' '}
//                         {summaryData.totalLeads
//                           ? ((summaryData.freshLeads / summaryData.totalLeads) * 100).toFixed(1)
//                           : 0}
//                         %
//                       </Typography>
//                       <Typography variant="body2">
//                         • Total leads acquired: {summaryData.totalLeads || 0}
//                       </Typography>
//                       {leadsData.length > 0 && (
//                         <Typography variant="body2">
//                           {(() => {
//                             const projectCounts = leadsData.reduce((acc, lead) => {
//                               const project = lead.projectName || lead.project?.name || 'Unknown';
//                               acc[project] = (acc[project] || 0) + 1;
//                               return acc;
//                             }, {});

//                             const projects = Object.entries(projectCounts);
//                             if (projects.length === 0) return '• No project data available';

//                             const sortedProjects = projects.sort((a, b) => b[1] - a[1]);
//                             return `• Top project: ${sortedProjects[0][0]} (${sortedProjects[0][1]} leads)`;
//                           })()}
//                         </Typography>
//                       )}
//                     </Stack>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Card variant="outlined" sx={{ height: '100%' }}>
//                   <CardContent>
//                     <Box display="flex" alignItems="center" mb={2}>
//                       <TrendingDown sx={{ color: 'error.main', mr: 1 }} />
//                       <Typography variant="subtitle1" color="error.main">
//                         ⚠️ Areas for Improvement
//                       </Typography>
//                     </Box>
//                     <Stack spacing={1}>
//                       <Typography variant="body2">
//                         • Cold leads ratio:{' '}
//                         {summaryData.totalLeads
//                           ? ((summaryData.coldLeads / summaryData.totalLeads) * 100).toFixed(1)
//                           : 0}
//                         %
//                       </Typography>
//                       <Typography variant="body2">
//                         • Consider increasing fresh lead engagement
//                       </Typography>
//                       <Typography variant="body2">• Focus on lead nurturing strategies</Typography>
//                     </Stack>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Paper>
//         </>
//       )}

//       {/* No Data State */}
//       {!reportLoading && !localReportData && selectedSales && (
//         <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 2, boxShadow: 2 }}>
//           <Box sx={{ maxWidth: 400, margin: '0 auto' }}>
//             <ShowChart sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
//             <Typography variant="h6" color="text.secondary" gutterBottom>
//               No Data Available
//             </Typography>
//             <Typography variant="body2" color="text.secondary" paragraph>
//               Select a sales person and date range to generate performance report
//             </Typography>
//             <Button
//               variant="contained"
//               startIcon={<Refresh />}
//               onClick={() => fetchReport(page, rowsPerPage)}
//               sx={{ mt: 2 }}
//             >
//               Generate Report
//             </Button>
//           </Box>
//         </Paper>
//       )}

//       {/* Modal لعرض تفاصيل الـ Lead */}
//       {selectedLead && (
//         <ShowClientsActionsAdvanced
//           user={selectedLead}
//           leadid={selectedLead._id}
//           open={showLeadDetails} // إضافة هذا
//           onClose={handleCloseLeadDetails}
//         />
//       )}

//       {/* Info Dialog */}
//       <Dialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)}>
//         <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
//           <Box display="flex" alignItems="center">
//             <Info sx={{ mr: 1 }} />
//             Information Required
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ mt: 2 }}>
//           <Typography variant="body1" paragraph>
//             <strong>Step 1:</strong> You should choose a sales person first
//           </Typography>
//           <Typography variant="body1">
//             <strong>Step 2:</strong> Then you can choose a date range or select a month
//           </Typography>
//           <Box mt={3} p={2} bgcolor="info.light" borderRadius={1}>
//             <Typography variant="body2">
//               <strong>Tip:</strong> Select a sales person from the dropdown menu, then you can
//               either:
//             </Typography>
//             <ul>
//               <li>Choose specific dates using the date pickers</li>
//               <li>Use the quick range buttons (Last Month, Last 3 Months, etc.)</li>
//               <li>Select a year from the dropdown and click on any month badge</li>
//               <li>Click "Current Month" to select the current month automatically</li>
//               <li>Export the report to Excel for further analysis</li>
//               <li>Click on any lead name to view detailed actions and information</li>
//             </ul>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setInfoDialogOpen(false)} color="primary">
//             Got it!
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };





















// 20-5-2026
import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Alert,
  Chip,
  IconButton,
  Tooltip,
  Stack,
  InputAdornment,
  Avatar,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  Refresh,
  TrendingUp,
  TrendingDown,
  Person,
  ShowChart,
  CalendarToday,
  Search,
  TableChart,
  Visibility,
  Info,
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { getsalespreformancereportaction } from '../Redux/Actions/UsersAction';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import XLSX from '../utils/excelUtils';
import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─── tiny icons ──────────────────────────────────────────────────────────── */
const IconRefresh  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>;
const IconDownload = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IconFilter   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCal      = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconSearch   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconUsers    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IconFire     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/><path d="M12 6v6l4 2"/></svg>;
const IconSnow     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="2" x2="12" y2="22"/><path d="M17 7l-5 5-5-5"/><path d="M17 17l-5-5-5 5"/></svg>;
const IconEye      = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IconChevL    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>;
const IconChevR    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>;

export const SalesReportCountLeadsInMonths = () => {
  const dispatch = useDispatch();
  const sidebarWidth = useSidebarWidth();
  const user = JSON.parse(localStorage.getItem('user'));

  const [selectedSales, setSelectedSales] = useState('');
  const [dateRange, setDateRange] = useState({
    fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [leadTypeFilter, setLeadTypeFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [exportLoading, setExportLoading] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showLeadDetails, setShowLeadDetails] = useState(false);
  const [localReportData, setLocalReportData] = useState(null);
  const [localLeadsData, setLocalLeadsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);

  const allSalesState = useSelector((state) => state.AllSales.sales);
  const allSales = Array.isArray(allSalesState?.data) ? allSalesState.data : [];
  const salesLoading = allSalesState?.loading || false;

  const months = [
    { id: 1, name: 'January', shortName: 'Jan', days: 31 },
    { id: 2, name: 'February', shortName: 'Feb', days: 28 },
    { id: 3, name: 'March', shortName: 'Mar', days: 31 },
    { id: 4, name: 'April', shortName: 'Apr', days: 30 },
    { id: 5, name: 'May', shortName: 'May', days: 31 },
    { id: 6, name: 'June', shortName: 'Jun', days: 30 },
    { id: 7, name: 'July', shortName: 'Jul', days: 31 },
    { id: 8, name: 'August', shortName: 'Aug', days: 31 },
    { id: 9, name: 'September', shortName: 'Sep', days: 30 },
    { id: 10, name: 'October', shortName: 'Oct', days: 31 },
    { id: 11, name: 'November', shortName: 'Nov', days: 30 },
    { id: 12, name: 'December', shortName: 'Dec', days: 31 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 7 }, (_, i) => currentYear - 5 + i);

  const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  const getDaysInMonth = (monthId, year) => {
    if (monthId === 2) return isLeapYear(year) ? 29 : 28;
    return months.find((m) => m.id === monthId)?.days || 31;
  };

  const handleOpenLeadDetails = (lead) => { setSelectedLead(lead); setShowLeadDetails(true); };
  const handleCloseLeadDetails = () => { setSelectedLead(null); setShowLeadDetails(false); };

  useEffect(() => { dispatch(Get_All_Sales_Action()); }, [dispatch]);
  useEffect(() => {
    if (user?.role === 'sales' && user?.salesId) setSelectedSales(user.salesId);
  }, []);
  useEffect(() => {
    if (selectedSales && dateRange.fromDate && dateRange.toDate) { setPage(0); fetchReport(); }
  }, [selectedSales, dateRange.fromDate, dateRange.toDate]);

  const fetchReport = async (pageNum = 0, limit = rowsPerPage) => {
    if (!selectedSales) { setError('Please select a sales person first'); setInfoDialogOpen(true); return; }
    try {
      setReportLoading(true); setError(null);
      const result = await dispatch(getsalespreformancereportaction({
        salesId: selectedSales, fromDate: dateRange.fromDate,
        toDate: dateRange.toDate, page: pageNum + 1, limit,
      }));
      if (result?.data?.data) {
        const reportData = result.data.data;
        setLocalReportData(reportData);
        if (reportData.leads) {
          setLocalLeadsData({ leads: reportData.leads, pagination: reportData.pagination, summary: reportData.summary });
        } else { setLocalLeadsData(null); }
      } else { setLocalReportData(result?.data || null); setLocalLeadsData(null); }
    } catch (err) { setError(err.message || 'Error loading report'); setLocalLeadsData(null); }
    finally { setReportLoading(false); }
  };

  const handleChangePage = (e, newPage) => { setPage(newPage); fetchReport(newPage, rowsPerPage); };
  const handleChangeRowsPerPage = (e) => {
    const n = parseInt(e.target.value, 10); setRowsPerPage(n); setPage(0); fetchReport(0, n);
  };

  const handleQuickDateRange = (m) => {
    if (!selectedSales) { setInfoDialogOpen(true); return; }
    const to = new Date(); const from = new Date(); from.setMonth(from.getMonth() - m);
    setDateRange({ fromDate: from.toISOString().split('T')[0], toDate: to.toISOString().split('T')[0] });
  };

  const handleMonthSelect = (monthId) => {
    if (!selectedSales) { setInfoDialogOpen(true); return; }
    const daysInMonth = getDaysInMonth(monthId, selectedYear);
    const firstDay = new Date(selectedYear, monthId - 1, 1);
    const lastDay = new Date(selectedYear, monthId - 1, daysInMonth);
    setSelectedMonth(monthId);
    setDateRange({ fromDate: firstDay.toISOString().split('T')[0], toDate: lastDay.toISOString().split('T')[0] });
  };

  const handleCurrentMonth = () => {
    if (!selectedSales) { setInfoDialogOpen(true); return; }
    const d = new Date(); setSelectedYear(d.getFullYear()); handleMonthSelect(d.getMonth() + 1);
  };

  const handleYearChange = (e) => {
    const y = parseInt(e.target.value); setSelectedYear(y);
    if (selectedMonth) setTimeout(() => handleMonthSelect(selectedMonth), 100);
  };

  const formatDateForExcel = (dateString) => {
    if (!dateString) return '';
    try { return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }); }
    catch { return dateString; }
  };

  const handleExportToExcel = async () => {
    if (!selectedSales || !localReportData) { setError('No data available to export'); return; }
    try {
      setExportLoading(true);
      let allLeads = []; let currentPage = 1; let hasMoreData = true; const pageSize = 200;
      while (hasMoreData) {
        try {
          const result = await dispatch(getsalespreformancereportaction({ salesId: selectedSales, fromDate: dateRange.fromDate, toDate: dateRange.toDate, page: currentPage, limit: pageSize }));
          if (result?.data?.leads && Array.isArray(result.data.leads)) {
            allLeads = [...allLeads, ...result.data.leads];
            const pagination = result.data.data?.pagination || {};
            if (pagination.hasNext && pagination.totalPages > currentPage) currentPage++;
            else hasMoreData = false;
          } else hasMoreData = false;
          if (allLeads.length >= 5000) hasMoreData = false;
        } catch { hasMoreData = false; }
      }
      if (allLeads.length === 0) throw new Error('No data available to export');
      const leadsDataForExport = allLeads.map((lead, index) => ({
        'No.': index + 1, 'Lead ID': lead._id || 'N/A', 'Name': lead.name || 'Unnamed Lead',
        'Email': lead.email || '', 'Phone': lead.phone || '',
        'Type': lead.leadType === 'fresh' ? 'Fresh' : 'Cold',
        'Project': lead.projectName || lead.project?.name || 'No Project',
        'Channel': lead.chanelName || lead.chanel?.name || '',
        'Sales Person': lead.salesName || lead.sales?.name || '',
        'Stage': lead.stageName || lead.stage?.name || '',
        'Assigned Date': lead.assignDate ? formatDateForExcel(lead.assignDate) : '',
        'Created Date': lead.createdAt ? formatDateForExcel(lead.createdAt) : '',
      }));
      const wb = XLSX.utils.book_new();
      const wsLeads = XLSX.utils.json_to_sheet(leadsDataForExport);
      XLSX.utils.book_append_sheet(wb, wsLeads, 'Leads Details');
      wsLeads['!cols'] = [{ wch: 8 }, { wch: 25 }, { wch: 20 }, { wch: 25 }, { wch: 15 }, { wch: 10 }, { wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
      const salesName = (selectedSalesInfo?.name || 'sales').replace(/[^a-zA-Z0-9]/g, '_');
      XLSX.writeFile(wb, `Sales_Report_${salesName}_${dateRange.fromDate}_to_${dateRange.toDate}.xlsx`);
      setError(null);
    } catch (err) { setError(err.message || 'Error exporting report'); }
    finally { setExportLoading(false); }
  };

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
    const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);
    return <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" style={{ fontSize: 12, fontWeight: 700 }}>{`${(percent * 100).toFixed(0)}%`}</text>;
  };

  const leadsData = localLeadsData?.leads || localReportData?.leads || localReportData?.data?.leads || [];
  const paginationData = localLeadsData?.pagination || localReportData?.pagination || localReportData?.data?.pagination || { total: leadsData.length, page: page + 1, limit: rowsPerPage, totalPages: Math.ceil(leadsData.length / rowsPerPage), hasNext: false, hasPrev: false };
  const summaryData = localLeadsData?.summary || localReportData?.summary || localReportData?.data?.summary || { freshLeads: 0, coldLeads: 0, totalLeads: 0 };

  const preparePieData = () => {
    const fresh = summaryData.freshLeads || leadsData.filter((l) => l.leadType === 'fresh').length || 0;
    const cold = summaryData.coldLeads || leadsData.filter((l) => l.leadType === 'cold').length || 0;
    return [{ name: 'Fresh Inquiries', value: fresh, color: '#f59e0b' }, { name: 'Demand(Cold) Leads', value: cold, color: '#0D47A1' }];
  };

  const selectedSalesInfo = allSales.find((s) => s._id === selectedSales) || null;
  const filteredLeads = leadsData.filter((lead) => {
    const matchesSearch = searchTerm === '' || (lead.name || '').toLowerCase().includes(searchTerm.toLowerCase()) || (lead.email || '').toLowerCase().includes(searchTerm.toLowerCase()) || String(lead.phone || '').includes(searchTerm);
    const matchesType = leadTypeFilter === 'all' || (lead.leadType || 'fresh') === leadTypeFilter;
    return matchesSearch && matchesType;
  });

  const formatDate = (d) => {
    if (!d) return 'N/A';
    try { return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }); }
    catch { return 'Invalid Date'; }
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const freshPct = summaryData.totalLeads ? ((summaryData.freshLeads / summaryData.totalLeads) * 100).toFixed(1) : 0;
  const coldPct = summaryData.totalLeads ? ((summaryData.coldLeads / summaryData.totalLeads) * 100).toFixed(1) : 0;

  /* ─────────────────────────────────────── render ──────────────────────── */
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .sp-root { font-family: 'Plus Jakarta Sans', sans-serif; }

        /* ── stat cards ── */
        .sp-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 24px; }
        .sp-stat-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1px solid #f0f0f0;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          position: relative; overflow: hidden;
        }
        .sp-stat-card .sp-stat-label { font-size: 11px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #9ca3af; margin-bottom: 6px; }
        .sp-stat-card .sp-stat-val   { font-size: 36px; font-weight: 800; color: #111827; line-height: 1.1; }
        .sp-stat-card .sp-stat-badge {
          display: inline-flex; align-items: center; gap: 4px; margin-top: 8px;
          font-size: 11px; font-weight: 600; padding: 3px 9px; border-radius: 20px;
        }
        .sp-stat-card .sp-stat-badge.up   { background: #dcfce7; color: #16a34a; }
        .sp-stat-card .sp-stat-badge.down { background: #fee2e2; color: #dc2626; }
        .sp-stat-card .sp-stat-icon {
          position: absolute; top: 18px; right: 20px; width: 40px; height: 40px;
          border-radius: 10px; display: flex; align-items: center; justify-content: center;
        }
        .sp-stat-card .sp-stat-icon.blue { background: #eff6ff; color: #0D47A1; }
        .sp-stat-card .sp-stat-icon.green{ background: #f0fdf4; color: #16a34a; }
        .sp-stat-card .sp-stat-icon.red  { background: #fff1f2; color: #ef4444; }
        .sp-stat-card .sp-stat-trend { font-size: 12px; color: #6b7280; margin-top: 4px; }

        /* ── filter bar ── */
        .sp-filter-bar {
          background: #fff; border-radius: 14px; padding: 20px 24px;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          margin-bottom: 24px;
        }
        .sp-filter-row { display: grid; grid-template-columns: 2fr 1fr 1fr auto; gap: 14px; align-items: end; }
        .sp-filter-label { font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #9ca3af; margin-bottom: 6px; display: block; }
        .sp-input {
          width: 100%; padding: 9px 12px; border-radius: 8px; font-size: 13px;
          border: 1.5px solid #e5e7eb; background: #f9fafb; color: #111827;
          font-family: 'Plus Jakarta Sans', sans-serif; outline: none; box-sizing: border-box;
          transition: border-color .2s;
        }
        .sp-input:focus { border-color: #0D47A1; background: #fff; }
        .sp-btn {
          padding: 9px 18px; border-radius: 8px; font-size: 13px; font-weight: 600;
          cursor: pointer; border: none; display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; transition: all .18s; white-space: nowrap;
        }
        .sp-btn-primary { background: #0D47A1; color: #fff; }
        .sp-btn-primary:hover { background: #0D47A1; }
        .sp-btn-ghost { background: #f1f5f9; color: #374151; }
        .sp-btn-ghost:hover { background: #e2e8f0; }
        .sp-btn-success { background: #059669; color: #fff; }
        .sp-btn-success:hover { background: #047857; }
        .sp-btn:disabled { opacity: .5; cursor: not-allowed; }

        /* quick chips */
        .sp-quick-chips { display: flex; align-items: center; gap: 8px; margin-top: 14px; flex-wrap: wrap; }
        .sp-qchip {
          padding: 5px 13px; border-radius: 20px; font-size: 12px; font-weight: 600;
          cursor: pointer; border: 1.5px solid #e5e7eb; background: #fff; color: #6b7280;
          transition: all .15s;
        }
        .sp-qchip:hover, .sp-qchip.active { border-color: #0D47A1; background: #eff6ff; color: #0D47A1; }

        /* month picker */
        .sp-month-picker { margin-top: 18px; }
        .sp-month-picker-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
        .sp-month-picker-title { font-size: 13px; font-weight: 700; color: #374151; }
        .sp-months-grid { display: flex; gap: 8px; flex-wrap: wrap; }
        .sp-month-chip {
          padding: 6px 14px; border-radius: 8px; font-size: 12px; font-weight: 600;
          cursor: pointer; border: 1.5px solid #e5e7eb; background: #fff; color: #6b7280;
          transition: all .15s;
        }
        .sp-month-chip:hover { border-color: #0D47A1; background: #eff6ff; color: #0D47A1; }
        .sp-month-chip.active { border-color: #0D47A1; background: #0D47A1; color: #fff; }

        /* sales info banner */
        .sp-sales-banner {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 18px; border-radius: 10px; background: linear-gradient(135deg, #0D47A1 0%, #0D47A1 100%);
          margin-top: 16px; color: #fff;
        }

        /* ── main grid ── */
        .sp-main-grid { display: grid; grid-template-columns: 340px 1fr; gap: 20px; margin-bottom: 24px; }

        /* pie card */
        .sp-pie-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        }
        .sp-card-title { font-size: 14px; font-weight: 700; color: #111827; margin-bottom: 4px; }
        .sp-card-sub   { font-size: 12px; color: #9ca3af; margin-bottom: 16px; }
        .sp-pie-legend { margin-top: 16px; }
        .sp-pie-leg-item { display: flex; align-items: center; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #f3f4f6; }
        .sp-pie-leg-item:last-child { border-bottom: none; }
        .sp-pie-leg-dot { width: 10px; height: 10px; border-radius: 3px; flex-shrink: 0; }
        .sp-pie-leg-label { font-size: 13px; color: #374151; flex: 1; margin-left: 10px; }
        .sp-pie-leg-val   { font-size: 13px; font-weight: 700; color: #111827; }
        .sp-pie-leg-pct   { font-size: 11px; color: #9ca3af; margin-left: 4px; }

        /* table card */
        .sp-table-card {
          background: #fff; border-radius: 14px; overflow: hidden;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          display: flex; flex-direction: column;
        }
        .sp-table-header { padding: 20px 24px 16px; border-bottom: 1px solid #f3f4f6; }
        .sp-table-header-row { display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
        .sp-search-wrap { position: relative; }
        .sp-search-wrap svg { position: absolute; left: 11px; top: 50%; transform: translateY(-50%); color: #9ca3af; pointer-events: none; }
        .sp-search-input {
          padding: 8px 12px 8px 34px; border-radius: 8px; font-size: 13px;
          border: 1.5px solid #e5e7eb; background: #f9fafb; color: #111827;
          font-family: 'Plus Jakarta Sans', sans-serif; outline: none; width: 220px;
        }
        .sp-search-input:focus { border-color: #0D47A1; background: #fff; }
        .sp-type-chips { display: flex; gap: 6px; }
        .sp-type-chip {
          padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 600;
          cursor: pointer; border: 1.5px solid #e5e7eb; background: #fff; color: #6b7280;
          transition: all .15s;
        }
        .sp-type-chip.all.active    { border-color: #0D47A1; background: #eff6ff; color: #0D47A1; }
        .sp-type-chip.fresh.active  { border-color: #059669; background: #f0fdf4; color: #059669; }
        .sp-type-chip.cold.active   { border-color: #dc2626; background: #fff1f2; color: #dc2626; }
        .sp-type-chip:hover         { border-color: #93c5fd; }

        /* table itself */
        .sp-table { width: 100%; border-collapse: collapse; }
        .sp-table thead th {
          padding: 11px 14px; font-size: 11px; font-weight: 700; letter-spacing: .06em;
          text-transform: uppercase; color: #6b7280; background: #f9fafb;
          border-bottom: 1px solid #f0f0f0; text-align: left; white-space: nowrap;
        }
        .sp-table tbody tr { border-bottom: 1px solid #f9fafb; transition: background .12s; }
        .sp-table tbody tr:hover { background: #f9fafb; }
        .sp-table tbody td { padding: 12px 14px; font-size: 13px; color: #374151; vertical-align: middle; }
        .sp-lead-name { font-weight: 600; color: #111827; font-size: 13px; cursor: pointer; }
        .sp-lead-name:hover { color: #0D47A1; text-decoration: underline; }
        .sp-lead-id   { font-size: 11px; color: #9ca3af; margin-top: 1px; }
        .sp-contact-info { font-size: 12px; color: #6b7280; line-height: 1.6; }
        .sp-badge {
          display: inline-flex; padding: 3px 10px; border-radius: 20px;
          font-size: 11px; font-weight: 700;
        }
        .sp-badge.fresh { background: #dcfce7; color: #15803d; }
        .sp-badge.cold  { background: #fee2e2; color: #dc2626; }
        .sp-action-btn {
          width: 30px; height: 30px; border-radius: 8px; border: 1.5px solid #e5e7eb;
          background: #fff; cursor: pointer; display: inline-flex; align-items: center;
          justify-content: center; color: #6b7280; transition: all .15s;
        }
        .sp-action-btn:hover { border-color: #0D47A1; color: #0D47A1; background: #eff6ff; }

        /* pagination */
        .sp-pagination {
          padding: 14px 20px; border-top: 1px solid #f3f4f6;
          display: flex; align-items: center; justify-content: space-between;
          background: #fff; flex-wrap: wrap; gap: 10px;
        }
        .sp-pag-info { font-size: 12px; color: #6b7280; }
        .sp-pag-btns { display: flex; gap: 4px; align-items: center; }
        .sp-pag-btn {
          width: 32px; height: 32px; border-radius: 8px; border: 1.5px solid #e5e7eb;
          background: #fff; cursor: pointer; display: flex; align-items: center;
          justify-content: center; font-size: 13px; font-weight: 600; color: #374151;
          transition: all .15s; font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .sp-pag-btn:hover   { border-color: #0D47A1; color: #0D47A1; background: #eff6ff; }
        .sp-pag-btn.active  { background: #0D47A1; border-color: #0D47A1; color: #fff; }
        .sp-pag-btn:disabled{ opacity: .4; cursor: not-allowed; }

        /* ledger / portfolio table section */
        .sp-ledger-card {
          background: #fff; border-radius: 14px; overflow: hidden;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          margin-bottom: 24px;
        }
        .sp-ledger-header {
          padding: 20px 24px; display: flex; align-items: center;
          justify-content: space-between; border-bottom: 1px solid #f3f4f6;
        }
        .sp-ledger-title { font-size: 15px; font-weight: 700; color: #111827; }
        .sp-ledger-row {
          padding: 16px 24px; display: grid;
          grid-template-columns: 60px 1fr 1fr 140px 160px 1fr 40px;
          align-items: center; gap: 12px; border-bottom: 1px solid #f9fafb;
          transition: background .12s;
        }
        .sp-ledger-row:hover { background: #f9fafb; }
        .sp-ledger-row-header { font-size: 10px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #9ca3af; background: #f9fafb; }
        .sp-avatar-sm { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 700; color: #fff; flex-shrink: 0; }

        /* empty state */
        .sp-empty { text-align: center; padding: 60px 20px; color: #9ca3af; }
        .sp-empty svg { margin-bottom: 12px; }
        .sp-empty p { font-size: 14px; }

        /* loading overlay */
        .sp-loading-overlay {
          display: flex; flex-direction: column; align-items: center;
          justify-content: center; padding: 40px; gap: 12px;
        }

        /* select styled */
        .sp-select {
          width: 100%; padding: 9px 12px; border-radius: 8px; font-size: 13px;
          border: 1.5px solid #e5e7eb; background: #f9fafb; color: #111827;
          font-family: 'Plus Jakarta Sans', sans-serif; outline: none; cursor: pointer;
          transition: border-color .2s;
        }
        .sp-select:focus { border-color: #0D47A1; }

        @media (max-width: 900px) {
          .sp-stats { grid-template-columns: 1fr 1fr; }
          .sp-main-grid { grid-template-columns: 1fr; }
          .sp-filter-row { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 600px) {
          .sp-stats { grid-template-columns: 1fr; }
          .sp-filter-row { grid-template-columns: 1fr; }
        }
      `}</style>

      <div
        className="sp-root"
        style={{
          position: 'fixed',
          top: '50px',
          left: sidebarWidth,
          right: 0,
          bottom: 0,
          transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
          overflowY: 'auto',
          overflowX: 'hidden',
          backgroundColor: '#f4f6fb',
        }}
      >
<div style={{ padding: '28px 28px 40px' }}>

          {/* ── Page Header ── */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
            <div>
              <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#111827' }}>Sales Performance</h1>
              <p style={{ margin: '4px 0 0', fontSize: 13, color: '#9ca3af' }}>Real-time portfolio metrics and lead conversions across global sectors.</p>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="sp-btn sp-btn-ghost" onClick={() => fetchReport(page, rowsPerPage)} disabled={reportLoading}>
                <IconRefresh /> Refresh
              </button>
              <button className="sp-btn sp-btn-primary" onClick={handleExportToExcel} disabled={!localReportData || exportLoading}>
                <IconDownload /> {exportLoading ? 'Exporting…' : 'Report Sales'}
              </button>
            </div>
          </div>

          {/* ── Filter Bar ── */}
          <div className="sp-filter-bar">
            <div className="sp-filter-row">
              {/* Sales Person */}
              <div>
                <span className="sp-filter-label">Sales Person</span>
                <select className="sp-select" value={selectedSales} onChange={(e) => setSelectedSales(e.target.value)} disabled={salesLoading}>
                  <option value="">All Sales Executives</option>
                  {allSales.map((s) => (
                    <option key={s._id} value={s._id}>{s.name || s._id}</option>
                  ))}
                </select>
              </div>

              {/* From */}
              <div>
                <span className="sp-filter-label">From Date</span>
                <input type="date" className="sp-input" value={dateRange.fromDate} onChange={(e) => setDateRange((p) => ({ ...p, fromDate: e.target.value }))} />
              </div>

              {/* To */}
              <div>
                <span className="sp-filter-label">To Date</span>
                <input type="date" className="sp-input" value={dateRange.toDate} onChange={(e) => setDateRange((p) => ({ ...p, toDate: e.target.value }))} />
              </div>

              {/* Granularity pills */}
              <div>
                <span className="sp-filter-label">View</span>
                <div style={{ display: 'flex', gap: 6 }}>
                  <span className="sp-qchip active">Monthly</span>
                  <span className="sp-qchip">Yearly</span>
                </div>
              </div>
            </div>

            {/* quick range */}
            <div className="sp-quick-chips">
              <span style={{ fontSize: 12, color: '#9ca3af', fontWeight: 600 }}>Quick:</span>
              {[{ label: 'Last Month', m: 1 }, { label: 'Last 3M', m: 3 }, { label: 'Last Year', m: 12 }].map(({ label, m }) => (
                <span key={m} className="sp-qchip" onClick={() => handleQuickDateRange(m)}>{label}</span>
              ))}
            </div>

            {/* month picker */}
            <div className="sp-month-picker">
              <div className="sp-month-picker-header">
                <span className="sp-month-picker-title">📅 Select Month & Year</span>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                  <span className="sp-qchip" onClick={handleCurrentMonth}>Current Month</span>
                  <select className="sp-select" style={{ width: 110 }} value={selectedYear} onChange={handleYearChange}>
                    {years.map((y) => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>
              </div>
              <div className="sp-months-grid">
                {months.map((m) => (
                  <span key={m.id} className={`sp-month-chip ${selectedMonth === m.id ? 'active' : ''}`} onClick={() => handleMonthSelect(m.id)}>
                    {m.shortName}
                  </span>
                ))}
              </div>
            </div>

            {/* sales person banner */}
            {selectedSalesInfo && (
              <div className="sp-sales-banner">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14, flexShrink: 0 }}>
                    {getInitials(selectedSalesInfo.name)}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 14 }}>{selectedSalesInfo.name}</div>
                    <div style={{ fontSize: 12, opacity: .75 }}>
                      {selectedSalesInfo.email && `${selectedSalesInfo.email}`}
                      {selectedSalesInfo.phone && ` · ${selectedSalesInfo.phone}`}
                    </div>
                  </div>
                </div>
                <button className="sp-btn" style={{ background: 'rgba(255,255,255,.15)', color: '#fff', border: '1.5px solid rgba(255,255,255,.3)' }} onClick={handleExportToExcel} disabled={!localReportData || exportLoading}>
                  <IconDownload /> Export Excel
                </button>
              </div>
            )}
          </div>

          {/* error */}
          {error && <div style={{ background: '#fff1f2', border: '1px solid #fecdd3', borderRadius: 10, padding: '12px 16px', color: '#dc2626', marginBottom: 16, fontSize: 13 }}>❌ {error}</div>}

          {/* loading bar */}
          {(reportLoading || exportLoading) && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ height: 3, background: '#e5e7eb', borderRadius: 2, overflow: 'hidden' }}>
                <div style={{ height: '100%', background: '#0D47A1', borderRadius: 2, animation: 'sp-progress 1.4s ease-in-out infinite', width: '40%' }} />
              </div>
              <style>{`@keyframes sp-progress { 0%{margin-left:-40%} 100%{margin-left:140%} }`}</style>
              <p style={{ textAlign: 'center', fontSize: 12, color: '#6b7280', marginTop: 8 }}>{exportLoading ? 'Exporting to Excel…' : 'Loading data…'}</p>
            </div>
          )}

          {/* ── STAT CARDS ── */}
          {localReportData && !reportLoading && (
            <>
              <div className="sp-stats">
                {/* Total Leads */}
                <div className="sp-stat-card">
                  <div className="sp-stat-label">Total Leads</div>
                  <div className="sp-stat-val">{(paginationData.total || summaryData.totalLeads || 0).toLocaleString()}</div>
                  <div><span className="sp-stat-badge up">↑ Active in period</span></div>
                  <div className="sp-stat-trend" style={{ marginTop: 6 }}>Acquired in selected period</div>
                  <div className="sp-stat-icon blue"><IconUsers /></div>
                </div>

                {/* Fresh */}
                <div className="sp-stat-card">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <div className="sp-stat-label">Fresh Acquisitions</div>
                      <div className="sp-stat-val" style={{ color: '#f59e0b' }}>{(summaryData.freshLeads || 0).toLocaleString()}</div>
                    </div>
                  </div>
                  <div>
                    <span className="sp-stat-badge up">↑ {freshPct}%</span>
                  </div>
                  <div className="sp-stat-trend" style={{ marginTop: 6 }}>New prospects</div>
                  <div className="sp-stat-icon green"><IconFire /></div>
                </div>

                {/* Cold */}
                <div className="sp-stat-card">
                  <div className="sp-stat-label">Cold Demand</div>
                  <div className="sp-stat-val" style={{ color: '#0D47A1' }}>{(summaryData.coldLeads || 0).toLocaleString()}</div>
                  <div><span className="sp-stat-badge down">↓ {coldPct}%</span></div>
                  <div className="sp-stat-trend" style={{ marginTop: 6 }}>Re-engaged prospects</div>
                  <div className="sp-stat-icon red"><IconSnow /></div>
                </div>
              </div>

              {/* ── MAIN GRID: Pie + Table ── */}
              <div className="sp-main-grid">

                {/* Pie */}
                <div className="sp-pie-card">
                  <div className="sp-card-title">Leads Distribution</div>
                  <div className="sp-card-sub">Breakdown by lead type</div>
                  <ResponsiveContainer width="100%" height={220}>
                    <PieChart>
                      <Pie data={preparePieData()} cx="50%" cy="50%" labelLine={false} label={renderCustomizedLabel} outerRadius={90} innerRadius={52} paddingAngle={4} dataKey="value">
                        {preparePieData().map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <RechartsTooltip formatter={(value, name) => [`${value} leads`, name]} contentStyle={{ borderRadius: 10, border: '1px solid #e5e7eb', fontSize: 12 }} />
                    </PieChart>
                  </ResponsiveContainer>

                  {/* center label */}
                  <div style={{ textAlign: 'center', marginTop: -10, marginBottom: 8 }}>
                    <div style={{ fontSize: 28, fontWeight: 800, color: '#111827' }}>
                      {preparePieData().reduce((s, i) => s + i.value, 0).toLocaleString()}
                    </div>
                    <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, letterSpacing: '.05em', textTransform: 'uppercase' }}>Total Leads</div>
                  </div>

                  <div className="sp-pie-legend">
                    {preparePieData().map((item) => (
                      <div key={item.name} className="sp-pie-leg-item">
                        <div className="sp-pie-leg-dot" style={{ background: item.color }} />
                        <span className="sp-pie-leg-label">{item.name}</span>
                        <span className="sp-pie-leg-val">{item.value.toLocaleString()}</span>
                        <span className="sp-pie-leg-pct">
                          {item.value ? `${((item.value / preparePieData().reduce((s, i) => s + i.value, 0)) * 100).toFixed(1)}%` : '0%'}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Table Card */}
                <div className="sp-table-card">
                  <div className="sp-table-header">
                    <div className="sp-table-header-row">
                      <div>
                        <div className="sp-card-title">📋 Leads Details</div>
                        <div className="sp-card-sub">
                          Showing {leadsData.length} of {paginationData.total} leads · Page {paginationData.page || page + 1} / {paginationData.totalPages || Math.ceil(paginationData.total / rowsPerPage)}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                        <div className="sp-search-wrap">
                          <IconSearch />
                          <input className="sp-search-input" placeholder="Search leads…" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                        <div className="sp-type-chips">
                          {['all', 'fresh', 'cold'].map((t) => (
                            <span key={t} className={`sp-type-chip ${t} ${leadTypeFilter === t ? 'active' : ''}`} onClick={() => { setLeadTypeFilter(t); setPage(0); }}>
                              {t.charAt(0).toUpperCase() + t.slice(1)}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ overflowX: 'auto', flex: 1 }}>
                    <table className="sp-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Lead</th>
                          <th>Contact</th>
                          <th>Type</th>
                          <th>Project</th>
                          <th>Assigned</th>
                          <th>Created</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportLoading ? (
                          <tr><td colSpan={8}><div className="sp-loading-overlay"><CircularProgress size={28} /><span style={{ fontSize: 13, color: '#6b7280' }}>Loading…</span></div></td></tr>
                        ) : (searchTerm || leadTypeFilter !== 'all' ? filteredLeads : leadsData).length === 0 ? (
                          <tr><td colSpan={8}><div className="sp-empty"><p>No leads found</p></div></td></tr>
                        ) : (
                          (searchTerm || leadTypeFilter !== 'all' ? filteredLeads : leadsData).map((lead, idx) => {
                            const itemNum = page * rowsPerPage + idx + 1;
                            const type = lead.leadType || 'fresh';
                            const avatarColors = ['#0D47A1', '#0D47A1', '#059669', '#f59e0b', '#ef4444'];
                            const color = avatarColors[idx % avatarColors.length];
                            return (
                              <tr key={lead._id}>
                                <td style={{ color: '#9ca3af', fontSize: 12 }}>{itemNum}</td>
                                <td>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <div style={{ width: 34, height: 34, borderRadius: 9, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 12, flexShrink: 0 }}>
                                      {getInitials(lead.name)}
                                    </div>
                                    <div>
                                      <div className="sp-lead-name" onClick={() => handleOpenLeadDetails(lead)}>{lead.name || 'Unnamed'}</div>
                                      <div className="sp-lead-id">ID: {lead._id?.slice(0, 8)}…</div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="sp-contact-info">
                                    {lead.email && <div>{lead.email}</div>}
                                    {lead.phone && <div>{lead.phone}</div>}
                                  </div>
                                </td>
                                <td><span className={`sp-badge ${type}`}>{type === 'fresh' ? 'Fresh' : 'Cold'}</span></td>
                                <td style={{ fontSize: 13, color: '#374151' }}>{lead.projectName || lead.project?.name || '—'}</td>
                                <td style={{ fontSize: 12, color: '#6b7280' }}>{formatDate(lead.assignDate || lead.createdAt)}</td>
                                <td style={{ fontSize: 12, color: '#6b7280' }}>{formatDate(lead.createdAt)}</td>
                                <td>
                                  <button className="sp-action-btn" title="View Details" onClick={() => handleOpenLeadDetails(lead)}>
                                    <IconEye />
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="sp-pagination">
                    <div className="sp-pag-info">
                      <span>Items per page: </span>
                      <select className="sp-select" style={{ display: 'inline-block', width: 64, padding: '4px 8px', marginLeft: 6 }}
                        value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                        {[5, 10, 25, 50].map((n) => <option key={n} value={n}>{n}</option>)}
                      </select>
                      <span style={{ marginLeft: 12 }}>
                        Showing <strong>{page * rowsPerPage + 1}–{Math.min((page + 1) * rowsPerPage, paginationData.total)}</strong> of <strong>{paginationData.total}</strong> leads
                      </span>
                    </div>
                    <div className="sp-pag-btns">
                      <button className="sp-pag-btn" onClick={() => handleChangePage(null, 0)} disabled={page === 0 || reportLoading}>⟨|</button>
                      <button className="sp-pag-btn" onClick={() => handleChangePage(null, page - 1)} disabled={page === 0 || reportLoading}><IconChevL /></button>
                      {Array.from({ length: Math.min(paginationData.totalPages || 1, 5) }, (_, i) => {
                        const totalPgs = paginationData.totalPages || Math.ceil(paginationData.total / rowsPerPage);
                        let p;
                        if (totalPgs <= 5) p = i;
                        else if (page < 3) p = i;
                        else if (page > totalPgs - 3) p = totalPgs - 5 + i;
                        else p = page - 2 + i;
                        return (
                          <button key={p} className={`sp-pag-btn ${page === p ? 'active' : ''}`} onClick={() => handleChangePage(null, p)} disabled={reportLoading}>{p + 1}</button>
                        );
                      })}
                      <button className="sp-pag-btn" onClick={() => handleChangePage(null, page + 1)} disabled={page >= (paginationData.totalPages || 1) - 1 || !paginationData.hasNext || reportLoading}><IconChevR /></button>
                      <button className="sp-pag-btn" onClick={() => handleChangePage(null, (paginationData.totalPages || 1) - 1)} disabled={page >= (paginationData.totalPages || 1) - 1 || reportLoading}>|⟩</button>
                    </div>
                  </div>
                </div>
              </div>

             
            </>
          )}

          {/* no data state */}
          {!reportLoading && !localReportData && selectedSales && (
            <div style={{ background: '#fff', borderRadius: 14, padding: 60, textAlign: 'center', border: '1px solid #f0f0f0' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>📊</div>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>No Data Available</p>
              <p style={{ color: '#9ca3af', fontSize: 13 }}>Select a sales person and date range to generate performance report</p>
              <button className="sp-btn sp-btn-primary" style={{ marginTop: 20 }} onClick={() => fetchReport(page, rowsPerPage)}>
                <IconRefresh /> Generate Report
              </button>
            </div>
          )}

          {!selectedSales && (
            <div style={{ background: '#fff', borderRadius: 14, padding: 60, textAlign: 'center', border: '1.5px dashed #e5e7eb' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>👆</div>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>Select a Sales Person</p>
              <p style={{ color: '#9ca3af', fontSize: 13 }}>Choose a sales executive from the dropdown above to view their performance report</p>
            </div>
          )}

        </div>
      </div>

      {/* Lead details modal */}
      {selectedLead && (
        <ShowClientsActionsAdvanced
          user={selectedLead}
          leadid={selectedLead._id}
          open={showLeadDetails}
          onClose={handleCloseLeadDetails}
        />
      )}

      {/* Info Dialog */}
      <Dialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ bgcolor: '#0D47A1', color: 'white', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          ℹ️ Information Required
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 14, color: '#374151' }}>
            <strong>Step 1:</strong> Choose a sales person from the dropdown first.<br />
            <strong>Step 2:</strong> Then select a date range or pick a month.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoDialogOpen(false)} sx={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 600 }}>Got it!</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};